import { css } from 'styled-components';
"use strict";
const SkeletonLoaderMixin = css`
  width: 100%;
  aspect-ratio: 1;
  position: absolute;
  overflow: hidden;
  border-radius: 6px;
  background-color: rgb(237 237 240 / 1);

  &::after {
    position: absolute;
    inset: 0;
    width: 140%; /* Matches parent diagonal length (pythagoras) */
    height: 200%; /* Arbitrary "width" to match wider horizontal lengths */
    transform: translate(-100%, -100%) rotate(45deg);
    background-image: linear-gradient(
      90deg,
      rgb(246 246 248 / 0) 0%,
      rgb(246 246 248 / 0.2) 20%,
      rgb(246 246 248 / 1) 60%,
      rgb(246 246 248 / 0) 100%
    );
    animation: shimmer 2s infinite;
    content: "";
  }

  @keyframes shimmer {
    100% {
      transform: translate(50%, 50%) rotate(45deg);
    }
  }
`;
const SkeletonLoaderDarkMixin = css`
  ${SkeletonLoaderMixin};

  background-color: rgb(18 18 15 / 1);

  &::after {
    background-image: linear-gradient(
      90deg,
      rgb(9 9 7 / 0) 0%,
      rgb(9 9 7 / 0.2) 20%,
      rgb(9 9 7 / 1) 60%,
      rgb(9 9 7 / 0) 100%
    );
  }
`;
export { SkeletonLoaderDarkMixin, SkeletonLoaderMixin };
//# sourceMappingURL=mixin.mjs.map
